<template>
  <div class="contact-mobile" :style="{'display':type === 1?'none':'flex'}">
    <div class="contact-mobile-item">
      <a rel="nofollow" href="https://teams.live.com/l/invite/FEAOtIKX0rDmnGUuwE" target="_blank">
        <img src="../assets/img/Teams.png" alt="Teams"/>
        <span class="strong-text">Teams</span>
      </a>
    </div>
    <div class="contact-mobile-item">
      <a rel="nofollow" href="mailto:mrk@youmi.net" target="_blank">
        <img src="../assets/img/i-email.png" alt="Email"/>
        <span class="strong-text">mrk@youmi.net</span>
      </a>
    </div>
    <div class="contact-mobile-item">
      <a rel="nofollow" href="https://wa.me/8618028539642" target="_blank">
        <img src="../assets/img/i-whatsapp.png" alt="WhatsApp"/>
        <span class="strong-text">WhatsApp</span>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: Number,
      default: 1,// 1代表是首次充值，0代表不是
    },
  }
}
</script>

<style lang="scss">
.contact-mobile{
  display: flex !important;
  align-items: center;
  flex-wrap: wrap;
  .contact-mobile-item{
    display: flex;
    align-items: center;
    margin-right: 10px;
    >a{
      text-decoration: none;
      width: 100%;
      height: 100%;
      padding: 0;
      display: flex;
      align-items: center;
      >img{
        width: 18px;
        height: 18px;
        margin-right: 2px;
      }
    }
    &:nth-child(2){
      >a{
        >img{
          width: 20px;
          height: 14px;
        }
      }
    }
    &:last-child{
      margin-right: 0;
    }
  }
}
@media screen and (max-width: 1100px){
  .contact-mobile{
    display: flex !important;
  }
}
</style>
